/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProductCollectionResponse as BackendCoreApiModelsAppPostProductCollectionResponse } from '../models/Backend/Core/Api/Models/App/Post/product-collection-response';

@Injectable({
  providedIn: 'root',
})
export class ProductBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProducts
   */
  static readonly GetProductsPath = '/api/product/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppPostProductCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppPostProductCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducts$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppPostProductCollectionResponse> {

    return this.getProducts$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppPostProductCollectionResponse>) => r.body as BackendCoreApiModelsAppPostProductCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppPostProductCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppPostProductCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducts$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Json(params?: {
  }): Observable<BackendCoreApiModelsAppPostProductCollectionResponse> {

    return this.getProducts$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppPostProductCollectionResponse>) => r.body as BackendCoreApiModelsAppPostProductCollectionResponse)
    );
  }

}
